module.exports = __webpack_public_path__ + "system/img/newdef1.200e0130.png";